export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: "NOMBRE LABORATORIO",
                    type: 'text',
                    key: 'name',
                },
                {
                    title: "RELACIÓN CONTRACTUAL",
                    type: 'text',
                    key: 'relationship',
                },
                ['OICC'].includes(this.activity) ? {
                    title: 'UNIDAD TÉCNICA',
                    type: 'text',
                    key: 'technical_unit',
                } : {},
                ['OEAP'].includes(this.activity) ? {
                    title: 'ACTIVIDAD',
                    type: 'text',
                    key: 'activity',
                } : {},
                ['OICC'].includes(this.activity) ? {
                    title: "MÉTODO DE ENSAYO",
                    type: 'text',
                    key: 'testing_method',
                } : {},
                {
                    title: "PERFIL DEL PERSONAL",
                    type: 'text',
                    key: 'profile',
                },
                ['OICC'].includes(this.activity) ? {
                    title: 'NOMBRE DEL PERSONAL CALIFICADO PARA CADA ENSAYO O ACTIVIDAD DESCRITA',
                    type: 'text',
                    key: 'qualified_personnel',
                } : {},
                ['OEAP'].includes(this.activity) ? {
                    title: 'AUTORIZACIÓN PARA',
                    type: 'text',
                    key: 'authorization_for',
                } : {},
                {
                    title: 'OBSERVACIONES',
                    type: 'text',
                    key: 'observations',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}